/* eslint-disable no-param-reassign, no-undef */

function scrollToTarget (target) {
  const yOffset = target.getBoundingClientRect().top + window.pageYOffset - 50
  window.scrollTo({
    top: yOffset,
    behavior: 'smooth'
  })

  setTimeout(() => {
    target.focus()
  }, 500)
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.hash) {
    scroll(0, 0)
    const target = document.querySelector(window.location.hash)
    if (target) {
      scrollToTarget(target)
    }
  }
})

const initAnchors = () => {
  let triggers = document.querySelectorAll('a[href*="#"]:not([href="#"]):not(#top)')

  triggers = Array.from(triggers)

  triggers.forEach((trigger) => {
    const targetId = trigger.hash.substring(1)
    const target = document.getElementById(targetId)

    trigger.addEventListener('click', (event) => {
      event.preventDefault()
      if (trigger.classList.contains('nav-link') || trigger.classList.contains('dropdown-item')) {
        document.body.classList.remove('js-nav-active')

        // Additional navigation cleanup
        const html = document.documentElement
        const container = document.getElementById('main-navigation-wrapper')
        const menu = container?.querySelector('ul')
        const button = document.getElementById('nav-toggle')

        if (html) html.classList.remove('disable-scroll')
        if (container) container.classList.remove('is-active')
        if (button) {
          button.classList.remove('is-active')
          button.setAttribute('aria-expanded', 'false')
        }
        if (menu) menu.setAttribute('aria-expanded', 'false')
      }

      // Check if the target element exists on the current page
      if (target) {
        // Scroll to the target element
        scrollToTarget(target)
      } else {
        // Navigate to the target page
        window.location.href = trigger.href
      }
    })
  })
}

export default initAnchors
